<template>
  <NuxtLayout></NuxtLayout>
  <div id="overlay-container"></div>
</template>
